import React from 'react';
import PropTypes from 'prop-types';
import SiteHeader from '../../includes/SiteHeader';
import Button from '../common/ButtonComponent';
import NavigateToWebApps from '../../utils/NavigateToWebApps';

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.goToBrochureWare = this.goToBrochureWare.bind(this);
    this.state = {};
  }

  goToBrochureWare() {
    NavigateToWebApps.navigateToBrochurewarePage(
      this.props.content.bankWebsite
    );
  }

  render() {
    const headerflagClass = 'nonbcustomer c-site-header__stacked';
    return (
      <div className="bow">
        <div className={`${headerflagClass}`}>
          <SiteHeader />
          <div className="container">
            <div className="row">
              <div className="pagelevel-error page errorpage-scroll">
                <div className="c-step-header--app-error u-text-center">
                  <div className="c-step-title">
                    <h2>{this.props.headerContent}</h2>
                  </div>
                  <p>{this.props.bodyContent1} </p>
                  <Button
                    btnName={this.props.buttonName2}
                    className={this.props.buttonClass2}
                    onClick={this.goToBrochureWare}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ErrorPage.propTypes = {
  headerContent: PropTypes.string,
  bodyContent1: PropTypes.string,
  bodyContent2: PropTypes.string,
  buttonName2: PropTypes.string,
};
ErrorPage.defaultProps = {
  headerContent: 'Something’s gone wrong',
  bodyContent1: 'Sorry, it looks like there’s been a technical problem.',
  buttonName2: 'Log out',
  buttonClass2: 'c-btn c-btn--default',
};
ErrorPage.displayName = 'UserDetailsErrorPage';
export default ErrorPage;
